require('./bootstrap');

require('alpine-magic-helpers');
require('alpinejs');
